import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex justify-center items-center mb-4" }
const _hoisted_3 = { class: "text-tertiary text-2xl font-semibold font-chakra mr-2" }
const _hoisted_4 = {
  key: 0,
  class: "block w-2 h-6 animate-caret-tertiary"
}
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "block w-2 h-10 animate-caret"
}
const _hoisted_7 = {
  key: 0,
  class: "text-lg font-medium text-center animate-fade"
}
const _hoisted_8 = {
  key: 0,
  class: "block bg-tertiary hover:bg-opacity-80 duration-500 text-white font-semibold px-8 py-4 rounded-md max-w-xs animate-fade",
  href: "#about"
}
const _hoisted_9 = { class: "mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading1 = _resolveComponent("Heading1")!
  const _component_NarrowContainer = _resolveComponent("NarrowContainer")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Container = _resolveComponent("Container")!
  const _component_Section = _resolveComponent("Section")!

  return (_openBlock(), _createBlock(_component_Section, {
    id: "hero",
    class: "bg-primary text-complementary flex"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Container, { class: "flex-1 flex flex-col items-center justify-between mt-4 mb-10 md:my-12 lg:my-16" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.greetingsDest), 1),
              (_ctx.loadingGreetings)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Heading1, { class: "font-chakra mr-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.fullNameDest), 1)
                ]),
                _: 1
              }),
              (_ctx.loadingFullName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_NarrowContainer, { class: "my-8 md:my-12" }, {
            default: _withCtx(() => [
              (!_ctx.loadingFullName && !_ctx.loadingGreetings)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("hero.description")), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (!_ctx.loadingFullName && !_ctx.loadingGreetings)
            ? (_openBlock(), _createElementBlock("a", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("hero.button")), 1),
                _createVNode(_component_FontAwesomeIcon, {
                  icon: "fa-solid fa-chevron-up",
                  rotation: 180
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}